// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"51d823ef","457":"00e44dab","851":"55855dc1"}[chunkId] + ".chunk.js";
};